import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useTeacherLanguagePost = (defaultId) => {
  const setTeacher = useCallback(
    ({ teacher_id: teacherId = defaultId, ...payload }) => {
      return new Request(
        `${MONOLITH_ORIGIN}/api/v2/teacher-languages/${teacherId}/`,
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: { "Content-Type": "application/json" },
        },
      );
    },
    [],
  );

  return useRestMutation(setTeacher);
};

export default useTeacherLanguagePost;
